module.exports = __webpack_public_path__ + "img/matr1x_fire_intro_banner_m.eb06af3f.png";